import { Component, OnChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.css']
})
export class ImageCropperComponent implements OnChanges {

  public file: File;
  public aspectRatio: number = 1;
  public roundCropper: boolean = false;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnChanges() {
  }

  croppedImage: string = '';

  imageCropped(event: ImageCroppedEvent) {
    if (event.base64) {
      this.croppedImage = event.base64;
    } else if (event.blob) {
      const reader = new FileReader();
      reader.readAsDataURL(event.blob);
      reader.onload = () => {
        this.croppedImage = reader.result as string;
      };
    }
  }

  save(): void {
    this.activeModal.close(this.croppedImage)
  }
}
